var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankOperations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.35 2.49992H15.8333C16.75 2.49992 17.5 3.24992 17.5 4.16659V15.8333C17.5 16.7499 16.75 17.4999 15.8333 17.4999H4.16667C3.25 17.4999 2.5 16.7499 2.5 15.8333V4.16659C2.5 3.24992 3.25 2.49992 4.16667 2.49992H7.65C8 1.53325 8.91667 0.833252 10 0.833252C11.0833 0.833252 12 1.53325 12.35 2.49992ZM10.8333 3.33325C10.8333 2.87492 10.4583 2.49992 10 2.49992C9.54167 2.49992 9.16667 2.87492 9.16667 3.33325C9.16667 3.79159 9.54167 4.16659 10 4.16659C10.4583 4.16659 10.8333 3.79159 10.8333 3.33325ZM8.93173 8.88347C8.93173 9.32329 9.23052 9.6057 10.1596 9.87884C11.0887 10.152 12.0833 10.6011 12.0833 11.9159C12.0833 12.865 11.4489 13.3881 10.6508 13.5594V14.5548H9.42289V13.5501C8.63703 13.3603 7.96578 12.7909 7.91667 11.777H8.81712C8.86215 12.3233 9.19368 12.7492 10.0368 12.7492C10.9414 12.7492 11.1419 12.24 11.1419 11.9205C11.1419 11.49 10.9373 11.0825 9.91405 10.8048C8.7721 10.4946 7.99034 9.96218 7.99034 8.89273C7.99034 7.99921 8.62885 7.41588 9.42289 7.22144V6.22144H10.6508V7.23532C11.5062 7.47144 11.936 8.20292 11.9646 8.99921H11.0601C11.0355 8.42051 10.7654 8.02699 10.0368 8.02699C9.34512 8.02699 8.93173 8.37884 8.93173 8.88347Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankOperations);
export default __webpack_public_path__ + "static/media/bankOperations.41a1fac28e98dc05754405537bc1b223.svg";
export { ForwardRef as ReactComponent };